type Callback = (value: string | null) => void

export function createLocalStorageKeyStore(key: string) {
  const listeners = new Set<Callback>()

  const get = (): string | null => {
    return localStorage.getItem(key)
  }

  const notify = (value: string | null) => {
    listeners.forEach((callback) => callback(value))
  }

  const set = (value: string) => {
    localStorage.setItem(key, value)
    notify(value)
  }

  const subscribe = (callback: Callback): (() => void) => {
    listeners.add(callback)
    return () => {
      listeners.delete(callback)
    }
  }

  const handleStorageEvent = (event: StorageEvent) => {
    if (event.key === key) {
      notify(event.newValue)
    }
  }

  window.addEventListener("storage", handleStorageEvent)

  return {
    get,
    set,
    subscribe,
  }
}
